import React, { useContext } from "react";
import Slider from "react-slick";
import "./style.css";
import { MyContext } from "../../App";
import { Link } from "react-router-dom";

const Banners = (props) => {
  const context = useContext(MyContext);

  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: context.windowWidth > 1200 ? 3 : context.windowWidth > 768 ? 2 : 1,
    slidesToScroll: 1,
    fade: false,
    arrows: context.windowWidth < 992 ? false : true,
    autoplay: true,
    autoplaySpeed: 4000,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        }
      }
    ]
  };

  // Default banner data if no props data is provided
  const defaultBanners = [
    {
      id: 1,
      title: "Cake Delivery",
      subtitle: "in 60 Mins",
      description: "Order Fresh Cakes for Every Celebration",
      buttonText: "ORDER NOW",
      buttonColor: "#e91e63",
      bgColor: "linear-gradient(135deg, #ffeaa7 0%, #fab1a0 100%)",
      textColor: "#2d3436",
      image: "/api/placeholder/400/250",
      link: "/products/category/cakes"
    },
    {
      id: 2,
      title: "Book a Magical",
      subtitle: "Candlelight Dinner Tonight",
      description: "Romantic set-ups starting ₹1499 | Available in 100+ cities",
      buttonText: "BOOK NOW",
      buttonColor: "#fd79a8",
      bgColor: "linear-gradient(135deg, #2d3436 0%, #636e72 100%)",
      textColor: "#ffffff",
      image: "/api/placeholder/400/250",
      link: "/products/category/dinner"
    },
    {
      id: 3,
      title: "There's Still Time for",
      subtitle: "Gift Delivery",
      description: "It's never too late to send thoughtful surprises",
      buttonText: "ORDER NOW",
      buttonColor: "#00b894",
      bgColor: "linear-gradient(135deg, #fdcb6e 0%, #e17055 100%)",
      textColor: "#2d3436",
      image: "/api/placeholder/400/250",
      link: "/products/category/gifts"
    },
    {
      id: 4,
      title: "Get Your Home Ready",
      subtitle: "for Any Celebration",
      description: "Beautiful home decoration services available",
      buttonText: "BOOK NOW",
      buttonColor: "#6c5ce7",
      bgColor: "linear-gradient(135deg, #a29bfe 0%, #74b9ff 100%)",
      textColor: "#ffffff",
      image: "/api/placeholder/400/250",
      link: "/products/category/decorations"
    }
  ];

  const bannerData = props?.data?.length > 0 ? props.data : defaultBanners;

  return (
    <div className="bannerSection">
      <div className="container-fluid">
        <Slider {...settings} className="bannerSlider">
          {bannerData.map((item, index) => {
            const isCustomBanner = props?.data?.length > 0;

            return (
              <div className="bannerSlide" key={index}>
                <div className="bannerBox">
                  {isCustomBanner ? (
                    // Original banner structure for admin-uploaded banners
                    <Link
                      to={item?.subCatId ? `/products/subCat/${item?.subCatId}` : `/products/category/${item?.catId}`}
                      className="bannerLink"
                    >
                      <div className="bannerImage">
                        <img
                          src={item?.images[0]}
                          className="w-100"
                          alt="banner"
                        />
                      </div>
                    </Link>
                  ) : (
                    // New modern banner design
                    <Link to={item.link} className="bannerLink">
                      <div
                        className="modernBanner"
                        style={{
                          background: item.bgColor,
                          color: item.textColor
                        }}
                      >
                        <div className="bannerContent">
                          <div className="bannerText">
                            <h2 className="bannerTitle">
                              {item.title}
                              <span className="bannerSubtitle">{item.subtitle}</span>
                            </h2>
                            <p className="bannerDescription">{item.description}</p>
                            <button
                              className="bannerButton"
                              style={{ backgroundColor: item.buttonColor }}
                            >
                              {item.buttonText}
                            </button>
                          </div>
                          <div className="bannerImageContainer">
                            <img
                              src={item.image}
                              alt={item.title}
                              className="bannerProductImage"
                            />
                          </div>
                        </div>
                        <div className="bannerDecorations">
                          <div className="decoration decoration1"></div>
                          <div className="decoration decoration2"></div>
                          <div className="decoration decoration3"></div>
                        </div>
                      </div>
                    </Link>
                  )}
                </div>
              </div>
            );
          })}
        </Slider>
      </div>
    </div>
  );
};

export default Banners;
